import './details/archive'
import './details/delete'
import './details/duplicate'
import './details/download'
import './details/restore'

import './list/create-wallet';



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/workflows/index.js